
import { Plus } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ContactList } from "./ContactList";
import { AddContactDialog } from "./AddContactDialog";

interface ContactsTabProps {
  clientId: string;
}

export const ContactsTab = ({ clientId }: ContactsTabProps) => {
  const [showAddContact, setShowAddContact] = useState(false);
  
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h2 className="text-lg font-semibold">Contacts</h2>
        <Button onClick={() => setShowAddContact(true)} size="sm">
          <Plus className="h-4 w-4 mr-2" />
          Add Contact
        </Button>
      </div>
      
      <ContactList clientId={clientId} />
      
      <AddContactDialog
        clientId={clientId}
        open={showAddContact}
        onOpenChange={setShowAddContact}
      />
    </div>
  );
};
